import { useTranslation } from "react-i18next";
import InputForm from "../../../../../components/input/input-register/InputForm";
import InputRadio from "../../../../../components/input/input-register/InputRadio";
import PhoneNumberForm from "../../../../../components/input/input-register/PhoneNumberForm";
import SelectForm from "../../../../../components/input/input-register/SelectForm";

const BusinessInformation = ({
    containerClass,
    formRefs,
    profileData,
    handleChangeProfile,
    errorsProfileData,
    businessData,
    businessTypeData,
    handleLiClickCountryList1,
    setProfileData,
    setErrorsProfileData
}) => {
    const { t } = useTranslation();

    return (
        <div className={containerClass}>
            <p className="tw:!text-[18px] tw:!font-[600] tw:!text-[#282828] tw:!mb-2">
                {t("businessRegister.businessInformation.title")} <span className="tw:text-red-600">*</span>
            </p>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-3 tw:!mb-3">
                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)]">
                    <InputForm
                        innerRef={formRefs.businessNameRef}
                        type={"text"}
                        suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                        label={t("businessRegister.businessInformation.form.businessName")}
                        placeholder={t("businessRegister.businessInformation.form.businessName")}
                        id={"businessName"}
                        name={"businessName"}
                        value={profileData.businessName}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.businessName}
                        invalidMessage={t(errorsProfileData.businessName)}
                    />
                </div>
                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)]">
                    <PhoneNumberForm
                        innerRef={formRefs.businessPhoneNumberRef}
                        id="businessPhoneNumber"
                        suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                        name="businessPhoneNumber"
                        label={t("businessRegister.businessInformation.form.businessPhoneNumber")}
                        placeholder={t("businessRegister.businessInformation.form.businessPhoneNumber")}
                        countryCode={profileData.businessCountryCode}
                        prefixPhoneNumber={profileData.businessPrefixNumber}
                        value={profileData.businessPhoneNumber}
                        onClickCountryList={handleLiClickCountryList1}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.businessPhoneNumber}
                        invalidMessage={t(errorsProfileData.businessPhoneNumber)}
                    />
                </div>
            </div>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-0 tw:lg:!gap-3 tw:mb-3">
                <div className="tw:!w-full tw:lg:!w-[calc(50%-0.375rem)] tw:!mb-0 tw:md:!mb-0">
                    <InputRadio
                        suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                        label={t("businessRegister.businessInformation.form.businessLocation")}
                        radioItem={[
                            {
                                label: t("businessRegister.businessInformation.radioLocation.withinJapan"),
                                name: "isJapanLoc",
                                value: profileData.businessLocInJapan,
                                changeValue: () => {
                                    setProfileData({
                                        ...profileData,
                                        businessLocInJapan: true,
                                    });
                                },
                            },
                            {
                                label: t("businessRegister.businessInformation.radioLocation.outsideJapan"),
                                name: "notJapanLoc",
                                value: !profileData.businessLocInJapan,
                                changeValue: () => {
                                    setProfileData({
                                        ...profileData,
                                        businessLocInJapan: false,
                                    });
                                },
                            }
                        ]}
                    />
                </div>
                <div className="tw:!w-full tw:lg:!w-[calc(50%-0.375rem)]">
                    <InputForm
                        innerRef={formRefs.businessAddressRef}
                        type={"text"}
                        suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                        label={t("businessRegister.businessInformation.form.businessAddress")}
                        placeholder={t("businessRegister.businessInformation.form.businessAddress")}
                        id={"businessAddress"}
                        name={"businessAddress"}
                        value={profileData.businessAddress}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.businessAddress}
                        invalidMessage={t(errorsProfileData.businessAddress)}
                    />
                </div>
            </div>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-3 tw:!mb-3">
                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)]">
                    <SelectForm
                        innerRef={formRefs.businessIndustryRef}
                        name={"businessIndustry"}
                        suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                        isSearchable={false}
                        options={businessData}
                        optionLabel={(option) => t(option.label)}
                        value={businessData.find(x => x.value === profileData.businessIndustry)}
                        onChange={(e) => {
                            setProfileData({
                                ...profileData,
                                businessIndustry: e.value,
                            });

                            const currentValidation = errorsProfileData;
                            delete currentValidation["businessIndustry"];
                            setErrorsProfileData(currentValidation);
                        }}
                        label={t("businessRegister.businessInformation.form.businessIndustry")}
                        placeholder={t("businessRegister.businessInformation.form.businessIndustry")}
                        isInvalid={errorsProfileData.businessIndustry}
                        invalidMessage={t(errorsProfileData.businessIndustry)}
                    />
                </div>
                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)]">
                    <SelectForm
                        innerRef={formRefs.businessTypeRef}
                        name={"businessType"}
                        suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                        isSearchable={false}
                        options={businessTypeData}
                        optionLabel={(option) => t(option.label)}
                        value={businessTypeData.find(x => x.value === profileData.businessType)}
                        onChange={(e) => {
                            setProfileData({
                                ...profileData,
                                businessType: e.value,
                            });

                            const currentValidation = errorsProfileData;
                            delete currentValidation["businessType"];
                            setErrorsProfileData(currentValidation);
                        }}
                        label={t("businessRegister.businessInformation.form.businessType")}
                        placeholder={t("businessRegister.businessInformation.form.businessType")}
                        isInvalid={errorsProfileData.businessType}
                        invalidMessage={t(errorsProfileData.businessType)}
                    />
                </div>
            </div>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-3 tw:!mb-3">
                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)]">
                    <div className="tw:!flex tw:!flex-wrap">
                        <div className="tw:!flex-1">
                            <InputForm
                                innerRef={formRefs.businessRegistrationNumberRef}
                                type={"text"}
                                suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                                label={t("businessRegister.businessInformation.form.businessRegistrationNumber")}
                                placeholder={t("businessRegister.businessInformation.form.businessRegistrationNumber")}
                                id={"businessRegistrationNumber"}
                                name={"businessRegistrationNumber"}
                                value={profileData.businessRegistrationNumber}
                                onChange={handleChangeProfile}
                                isInvalid={errorsProfileData.businessRegistrationNumber}
                                invalidMessage={t(errorsProfileData.businessRegistrationNumber)}
                            />
                        </div>
                    </div>
                </div>
                <div className="tw:!w-full tw:md:!w-[calc(50%-0.375rem)]">
                    <div className="tw:!flex tw:!flex-wrap">
                        <div className="tw:!flex-1">
                            <InputForm
                                innerRef={formRefs.iataNumber}
                                type={"text"}
                                suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                                label={t("businessRegister.businessInformation.form.iataNumber.label")}
                                infoLabel={t("businessRegister.businessInformation.form.iataNumber.infoLabel")}
                                placeholder={t("businessRegister.businessInformation.form.iataNumber.label")}
                                id={"iataNumber"}
                                name={"iataNumber"}
                                value={profileData.iataNumber}
                                onChange={handleChangeProfile}
                                isInvalid={errorsProfileData.iataNumber}
                                invalidMessage={t(errorsProfileData.iataNumber)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw:!flex tw:!flex-wrap tw:!gap-3 tw:!mb-3">
                <div className="tw:!flex-1">
                    <div className="tw:!flex tw:!flex-wrap">
                        <div className="tw:!flex-1">
                            <InputForm
                                innerRef={formRefs.contactWebsite}
                                type={"text"}
                                suffixClass={"tw:!mb-0 tw:!text-[14px]"}
                                label={t("businessRegister.businessInformation.form.website.label")}
                                infoLabel={t("businessRegister.businessInformation.form.website.infoLabel")}
                                placeholder={t("businessRegister.businessInformation.form.website.label")}
                                id={"website"}
                                name={"website"}
                                value={profileData.website}
                                onChange={handleChangeProfile}
                                isInvalid={errorsProfileData.website}
                                invalidMessage={t(errorsProfileData.website)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BusinessInformation;
